import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=4796cd5f&scoped=true&"
import script from "./LogDetails.vue?vue&type=script&lang=js&"
export * from "./LogDetails.vue?vue&type=script&lang=js&"
import style0 from "./LogDetails.vue?vue&type=style&index=0&id=4796cd5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4796cd5f",
  null
  
)

export default component.exports